import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core'
import { faChartBar, faList } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'

type ToggleProps = {
  isTableView: boolean
  toggle: () => void
  viewIcon?: IconDefinition
  label: string
}

const Toggle = ({ isTableView, toggle, viewIcon, label }: ToggleProps) => {
  const selectedValue = `${isTableView}`
  return (
    <ToggleButtonGroup
      exclusive
      aria-label={`view ${label} options`}
      value={selectedValue}
      onChange={(_, value) => {
        if (value !== null) {
          toggle()
        }
      }}
    >
      <ToggleButton
        aria-label={`view ${label} chart`}
        value="false"
      >
        <FontAwesomeIcon icon={(viewIcon || faChartBar) as IconProp} />
      </ToggleButton>
      <ToggleButton
        aria-label={`view ${label} table`}
        value="true"
      >
        <FontAwesomeIcon icon={faList as IconProp} />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default Toggle
